export const INITIAL_STATE = {
  AppImages: null,
  WebArticles: {},
  WebVideos: null,
  Centers: null,
  Genders: null,
  Countries: null,
  Messages: null,
  Languages: null,
  PhoneTypes: null,
  Ethnicity: null,
  States: null,
  //
  getLoyaltyAchievementBadgesLoading: false,
  getLoyaltyAchievementBadgesSuccess: null,
  getLoyaltyAchievementBadgesFailure: null,
  //
  blogsCategoryList: [],

  messages: [],
  messagesFiltered: [],
  messagesClosed: [],
  //
  BannerMessage: null,
  BannerOpen: false,
  BannerLastUpdate: null,

  parsedMenuItems: null,

  getLoyaltyMilestonesLoading: false,
  getLoyaltyMilestonesSuccess: null,
  getLoyaltyMilestonesFailure: null,
  //
  getMessagesLoading: false,
  getMessagesSuccess: null,
  getMessagesFailure: null,
  //
  getCentersLoading: false,
  getCentersSuccess: null,
  getCentersFailure: null,
  //
  getCentersForMobileLoading: false,
  getCentersForMobileSuccess: null,
  getCentersForMobileFailure: null,
  //
  getGendersLoading: false,
  getGendersSuccess: null,
  getGendersFailure: null,
  //
  getCountriesLoading: false,
  getCountriesSuccess: null,
  getCountriesFailure: null,
  //
  getAllStatesLoading: false,
  getAllStatesSuccess: null,
  getAllStatesFailure: null,
  //
  getLanguagesLoading: null,
  getLanguagesSuccess: null,
  getLanguagesFailure: null,
  //
  getPhoneTypesLoading: null,
  getPhoneTypesSuccess: null,
  getPhoneTypesFailure: null,

  getEthnicityOptionsLoading: null,
  getEthnicityOptionsSuccess: null,
  getEthnicityOptionsFailure: null,

  saveContactFormLoading: null,
  saveContactFormSuccess: null,
  saveContactFormFailure: null,

  getRedeemPaused: null,
  getRedeemPausedLoading: false,
  getRedeemPausedSuccess: null,
  getRedeemPausedFailure: null,

  getVendorRedeemPaused: null,
  getVendorRedeemPausedLoading: false,
  getVendorRedeemPausedSuccess: null,
  getVendorRedeemPausedFailure: null,

  drupalMenuSuccess: {},
  drupalMenuLoading: {},
  drupalMenuFailure: {},

  getDrupalHomepage: null,
  getDrupalHomepageLoading: false,
  getDrupalHomepageSuccess: null,
  getDrupalHomepageFailure: null,

  getDrupalNavigation: null,
  getDrupalNavigationLoading: false,
  getDrupalNavigationSuccess: null,
  getDrupalNavigationFailure: null,

  getPatientTestimonials: null,
  getPatientTestimonialsLoading: false,
  getPatientTestimonialsSuccess: null,
  getPatientTestimonialsFailure: null,

  getFormsPageSuccess: {},
  getFormsPageLoading: {},
  getFormsPageFailure: {},

  getCustomPage: null,
  getCustomPageLoading: false,
  getCustomPageSuccess: null,
  getCustomPageFailure: null,

  getPromotionalBanner: null,
  getPromotionalBannerLoading: false,
  getPromotionalBannerSuccess: null,
  getPromotionalBannerFailure: null,

  getRegistrationPageSuccess: {},
  getRegistrationPageLoading: {},
  getRegistrationPageFailure: {},

  getLocationsPage: null,
  getLocationsPageLoading: false,
  getLocationsPageSuccess: null,
  getLocationsPageFailure: null,

  getCenterDetailsPage: null,
  getCenterDetailsLoading: false,
  getCenterDetailsSuccess: null,
  getCenterDetailsFailure: null,

  getPostLoginPage: null,
  getPostLoginPageLoading: false,
  getPostLoginPageSuccess: null,
  getPostLoginPageFailure: null,

  getMobileScreenData: null,
  getMobileScreenDataLoading: false,
  getMobileScreenDataSuccess: null,
  getMobileScreenDataFailure: null,

  getOnboardingScreenData: null,
  getOnboardingScreenDataLoading: false,
  getOnboardingScreenDataSuccess: null,
  getOnboardingScreenDataFailure: null,

  getBlogsPage: null,
  getBlogsPageLoading: false,
  getBlogsPageSuccess: null,
  getBlogsPageFailure: null,

  getNewsPage: null,
  getNewsPageLoading: false,
  getNewsPageSuccess: null,
  getNewsPageFailure: null,
};
